export const PhoneIcon = (props) => (
  <svg
    className={props.className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9601 11.6673C9.70375 11.6673 8.44158 11.3752 7.17358 10.791C5.9057 10.2068 4.7397 9.38265 3.67559 8.31865C2.61581 7.25454 1.79381 6.08954 1.20959 4.82365C0.625363 3.55787 0.333252 2.29682 0.333252 1.04048C0.333252 0.840485 0.399919 0.672707 0.533252 0.537151C0.666585 0.401707 0.833252 0.333984 1.03325 0.333984H3.20759C3.37592 0.333984 3.52442 0.388929 3.65309 0.498818C3.78175 0.608596 3.86359 0.744262 3.89859 0.905818L4.28075 2.86732C4.3072 3.04932 4.30164 3.20571 4.26409 3.33648C4.22642 3.46726 4.15886 3.5771 4.06142 3.66598L2.52175 5.16482C2.76953 5.6186 3.05264 6.04787 3.37108 6.45265C3.68942 6.85732 4.03409 7.24382 4.40509 7.61215C4.77086 7.97804 5.15975 8.31782 5.57175 8.63148C5.98375 8.94515 6.42864 9.23704 6.90642 9.50715L8.40242 7.99815C8.50675 7.8896 8.63309 7.81348 8.78142 7.76982C8.92964 7.72626 9.0837 7.7156 9.24358 7.73782L11.0948 8.11482C11.2631 8.15926 11.4005 8.24515 11.5069 8.37248C11.6134 8.49982 11.6666 8.64426 11.6666 8.80582V10.9673C11.6666 11.1673 11.5989 11.334 11.4634 11.4673C11.3279 11.6007 11.1601 11.6673 10.9601 11.6673Z"
      fill="#09AC45"
    />
  </svg>
);
